import mainReducer from "./main/reducer"

export default {
	main: mainReducer,
}



// WEBPACK FOOTER //
// ./src/redux/reducers.js